export default __webpack_public_path__ + "static/media/IMG-20210326-WA0032.af716e36.jpg";